import React, { useState, useEffect } from "react";
import statusService from "../../../services/statusService.js";

const ModalStatus = ({ isOpen, onClose, editingStatus, clientId, loadContent, colorPalette }) => {
    const [formData, setFormData] = useState({
        name: "",
        client_id: clientId,
        color: "#7f8c8d",
        is_final: false,
    });
    const [color, setColor] = useState('#7f8c8d');

    useEffect(() => {
        if (editingStatus) {
            setFormData({
                name: editingStatus.name || "",
                client_id: editingStatus.client_id || "",
                color: editingStatus.color || "#7f8c8d",
                is_final: editingStatus.is_final || false,
            });
            setColor(editingStatus.color || "#7f8c8d");
        } else {
            setFormData({
                name: "",
                client_id: clientId,
                color: "#7f8c8d",
                is_final: false,
            });
            setColor("#7f8c8d");
        }
    }, [editingStatus, clientId]);

    const handleColorSelect = (selectedColor) => {
        setColor(selectedColor);
        setFormData((prev) => ({ ...prev, color: selectedColor }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = { ...formData };

        if (editingStatus) {
            statusService.setStatus(editingStatus.id, payload).then(() => {
                loadContent();
                onClose();
            });
        } else {
            statusService.createStatus(payload).then(() => {
                loadContent();
                onClose();
            });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
                <h2 className="modal-title">
                    {editingStatus ? "Editar Estado" : "Crear Estado"}
                </h2>
                <form onSubmit={handleSubmit}>
                    {clientId && (
                        <input type="hidden" name="client_id" value={formData.client_id} />
                    )}

                    <div className="form-group">
                        <label htmlFor="name">Nombre</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Switch moderno */}
                    <div className="form-check form-switch mt-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="is_final"
                            name="is_final"
                            checked={formData.is_final}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="is_final">
                            Este estado finaliza la tarea
                        </label>
                    </div>

                    <div className="form-group mt-3">
                        <label>Selecciona un color para el estado</label>
                        <div className="color-palette mt-2 mb-2">
                            {colorPalette.map((colorValue) => (
                                <button
                                    className="color-palette-circle"
                                    type="button"
                                    key={colorValue}
                                    style={{
                                        backgroundColor: colorValue,
                                        border: colorValue === color ? '4px solid black' : '4px solid white'
                                    }}
                                    onClick={() => handleColorSelect(colorValue)}
                                />
                            ))}
                        </div>

                        <label htmlFor="hex-value">Valor hexadecimal</label>
                        <input
                            type="text"
                            id="hex-value"
                            value={color}
                            readOnly
                            className="form-control"
                        />
                    </div>

                    <div className="mt-4">
                        <button type="submit" className="btn btn-success">
                            <i className="bi bi-save me-2"></i>
                            {editingStatus ? "Actualizar" : "Crear"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary ms-2"
                            onClick={onClose}
                        >
                            <i className="bi bi-x-circle me-2"></i>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalStatus;
